import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { Authentication } from '../../providers/authentication';

/*
  Generated class for the Receipts page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-receipts',
  templateUrl: 'receipts.html'
})
export class ReceiptsPage {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authService: Authentication
  ) {}

  ionViewCanEnter() {
    return this.authService.isAuthenticated().toPromise();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReceiptsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/receipts/receipts.ts